module.exports = __webpack_public_path__ + "static/028_001-9a9fe2bde617a96ed73b053ca2616706.jpg";